"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = trim;
/**
 * Obcina początkowe i końcowe spacje w tekscie
 * @param text tekst do obcięcia
 */
function trim(text) {
    return (text || '').trim();
}
//# sourceMappingURL=trim.js.map